import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20background%20with%20warm%20golden%20stage%20lights%2C%20abstract%20film%20grain%20texture%2C%20elegant%20cinema%20atmosphere%2C%20luxurious%20dark%20red%20and%20gold%20accents%2C%20dramatic%20lighting%20with%20soft%20glow%20effects%2C%20cinematic%20composition%2C%20high%20contrast&width=1600&height=900&seq=hero-bg&orientation=landscape"
        alt="八戒影院 - 高清免费在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center mb-6">
          <i className="ri-movie-2-fill text-5xl md:text-6xl text-primary-500"></i>
        </div>
        <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 max-w-3xl">
          八戒影院 - 高清免费在线观看
        </h1>
        <p className="text-sm md:text-base text-foreground-700 max-w-2xl mb-8 leading-relaxed">
          海量高清免费影视在线观看，无需缓冲流畅播放。涵盖电视剧全集、电影大全及最新影视资源，每日同步更新，免费畅享。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即观影
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-foreground-400/40 text-foreground-800 font-medium text-sm rounded-md hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}